import FlexModal from '~/view/ui/reusables/FlexModal';
import React, { createContext, useState } from 'react';
import { modalInitState } from '~/utils/config';

export const ModalStateContext = createContext();

export function ModalProvider(props) {
  const [modalState, setModalState] = useState(modalInitState);
  const [userDamages, setUserDamages] = useState([]);
  const [reportDamageList, setReportDamageList] = useState([]);

  return (
    <ModalStateContext.Provider
      value={{
        modalState,
        userDamages,
        setModalState,
        setUserDamages,
        reportDamageList,
        setReportDamageList,
      }}
    >
      {props.children}
      {modalState.state && <FlexModal />}
    </ModalStateContext.Provider>
  );
}
